import $ from 'jquery';
import React from 'react';
import { DictPicker } from '../../simple/select/DictPicker.jsx';
import { connect } from 'react-redux';
import Fuse from 'fuse.js';
import { getProductListWrapper } from './ProductWrapper';
import { handleFormChanged } from '@/store/allaround.store.js';
import OptionComponent from '../../simple/select/DictOption';

export const fuzzyMatchProduct = (data, searchString) => {
  if (searchString.trim().length == 0) {
    return data;
  }
  const options = {
    caseSensitive: false,
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 100,
    keys: ['label'],
    getFn(object, path) {
      return object[path].replace(/ \/ +/, '');
    },
  };

  const fuse = new Fuse(data, options);
  return fuse.search(searchString);
};
export function transformDictData(data) {
  return !data ? undefined : data.flatMap((product) =>
    product.get('productTypes').map((type) => ({
      value: type.get('id'),
      label: `${product.get('name')}${type.get('name') == 'DEFAULTPRODUCTTTYPE'
        ? '' : ` / ${type.get('name')}`}`,
      product: product.get('id'),
      hidden: type.get('hidden') || product.get('hidden'),
    })
    )).toJS();
}

class ProductPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: props.data ? props.data : undefined };
  }

  componentWillMount() {
    getProductListWrapper();
    this.createData(this.props);
  }
  componentWillReceiveProps(props) {
    getProductListWrapper();
    this.createData(props);
  }
  createData(props) {
    if (props.data != undefined && props.data != null) {
      let transformedData = transformDictData(props.data);
      if (props.filteredData) {
        transformedData = transformedData
          .filter(elem => props.filteredData.indexOf(elem.value) >= 0);
      }
      if (props.productsSelected !== undefined) {
        this.setState({ data: transformedData
          .filter(prod => $.inArray(prod.value, props.productsSelected) > -1) });
      } else {
        this.setState({ data: transformedData });
      }
    }
  }

  render() {
    let component;
    if (this.state.data) {
      component = (<DictPicker
        noAddButton
        clearable={this.props.clearable}
        onChangeFunc={this.props.onChangeFunc}
        data={this.state.data.slice()}
        disabled={this.props.disabled}
        filterOptions={fuzzyMatchProduct}
        name={this.props.name}
        optionComponent={OptionComponent}
        defaultValue={this.props.defaultValue}
        handleFormChanged={this.props.handleFormChanged}
        dict="product"
      />);
    } else {
      component = <div></div>;
    }
    return component;
  }
}
ProductPicker.propTypes = {
  data: React.PropTypes.oneOfType(
    [React.PropTypes.array,
      React.PropTypes.object]),
  name: React.PropTypes.string,
  onChangeFunc: React.PropTypes.func,
  defaultValue: React.PropTypes.number,
  productsSelected: React.PropTypes.array,
  handleFormChanged: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  clearable: React.PropTypes.bool,
};

export default connect((state) => ({
  data: state.getIn(['references', 'complex', 'product']),
}), (dispatch) => ({
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(ProductPicker);
